import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { ServiceOrder } from '@mews-commander/data-access';
import { getServiceOrder } from '@mews-commander/legacy-entities/src/ducks/serviceOrders';
import {
    areAllServiceOrderItemsClosed,
    areAllServiceOrderItemsRebated,
    areAllServiceOrderItemsRebates,
    areSomeServiceOrderItemsRebated,
    getServiceOrderItemsCollectiveRebateIndex,
} from '../../../../rebate/selectors/orderItems';

interface OwnProps {
    serviceOrderId: string;
    billId: string;
    serviceId: string;
}
interface StateProps {
    serviceOrder: ServiceOrder;
    areAllServiceOrderItemsRebated: boolean;
    areSomeServiceOrderItemsRebated: boolean;
    areAllServiceOrderItemsRebates: boolean;
    areAllServiceOrderItemsClosed: boolean;
    collectiveRebateIndex?: number;
}

export const connectServiceOrderItemLabel = connect<StateProps, null, OwnProps, ApplicationState>(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        serviceOrder: (state: ApplicationState, { serviceOrderId }: OwnProps) =>
            getServiceOrder(state, { id: serviceOrderId }),
        areAllServiceOrderItemsRebated,
        areSomeServiceOrderItemsRebated,
        areAllServiceOrderItemsRebates,
        areAllServiceOrderItemsClosed,
        collectiveRebateIndex: getServiceOrderItemsCollectiveRebateIndex,
    })
);
